export const pattern4Data = [
  {
    id: 1,
    koreanChunks: [
      "그 회사는",
      "제공했다",
      "그 회사의 최고 실적을 낸 영업 사원들에게",
      "모든 비용이 이미 지불된 여행을",
      "독점적 리더십 컨퍼런스로의",
      "싱가포르에",
    ],
    englishChunks: [
      "The company",
      "offered",
      "its top-performing sales representatives",
      "an all-expenses-paid trip",
      "to an exclusive leadership conference",
      "in Singapore",
    ],
    fullEnglish:
      "The company offered its top-performing sales representatives an all-expenses-paid trip to an exclusive leadership conference in Singapore.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 2,
    koreanChunks: [
      "인사부는",
      "부여했다",
      "신입 직원들에게",
      "접근 권한을",
      "회사의 내부 커뮤니케이션 플랫폼 및 학습 관리 시스템에 대한 ",
    ],
    englishChunks: [
      "The HR department",
      "granted",
      "newly hired employees",
      "access",
      "to the company's internal communication platform and learning management system",
    ],
    fullEnglish:
      "The HR department granted newly hired employees access to the company's internal communication platform and learning management system.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 3,
    koreanChunks: [
      "공급업체는",
      "보냈다",
      "물류 부서에",
      "상세한 배송 추적 보고서를",
      "그..포함하는 예상 배송시간을",
      "모든 보류중인 주문에 대한",
    ],
    englishChunks: [
      "The supplier",
      "sent",
      "the logistics department",
      "a detailed shipment tracking report",
      "containing estimated delivery times",
      "for all pending orders",
    ],
    fullEnglish:
      "The supplier sent the logistics department a detailed shipment tracking report containing estimated delivery times for all pending orders.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 4,
    koreanChunks: [
      "그 비영리 단체는",
      "제공했다",
      "저소득층 학생들에게",
      "농촌 지역의",
      "장학금을",
      "그..포함하는 전액 학비와 교육 자료를 ",
    ],
    englishChunks: [
      "The non-profit organization",
      "provided",
      "underprivileged students",
      "in rural areas",
      "scholarships",
      "covering full tuition fees and educational materials",
    ],
    fullEnglish:
      "The non-profit organization provided underprivileged students in rural areas scholarships covering full tuition fees and educational materials.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 5,
    koreanChunks: [
      "이사회는",
      "수여했다",
      "연구팀에게",
      "상당한 연구비 지원금을",
      "그들의 획기적인 연구를 위해 ",
      "재생 가능 에너지 기술 분야에서의",
    ],
    englishChunks: [
      "The board of directors",
      "awarded",
      "the research team",
      "a significant funding grant",
      "for their groundbreaking work",
      "in renewable energy technology",
    ],
    fullEnglish:
      "The board of directors awarded the research team a significant funding grant for their groundbreaking work in renewable energy technology.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 6,
    koreanChunks: [
      "프로젝트 매니저는",
      "요청했다",
      "엔지니어링 팀에게",
      "즉각적인 피드백을",
      "프로토타입의 기능성과 개선 가능성에 대한 ",
    ],
    englishChunks: [
      "The project manager",
      "asked",
      "the engineering team",
      "immediate feedback ",
      "on the prototype's functionality and potential improvements",
    ],
    fullEnglish:
      "The project manager asked the engineering team immediate feedback on the prototype's functionality and potential improvements.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 7,
    koreanChunks: [
      "노동 조합은",
      "요구했다",
      "회사 경영진에게",
      "더 나은 임금, 출산 휴가 연장, 그리고 개선된 직장 안전 조치를",
    ],
    englishChunks: [
      "The labor union",
      "demanded",
      "the company executives",
      "better wages, extended maternity leave, and improved workplace safety measures",
    ],
    fullEnglish:
      "The labor union demanded the company executives better wages, extended maternity leave, and improved workplace safety measures.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 8,
    koreanChunks: [
      "CEO는",
      "약속했다",
      "투자자들에게",
      "상당한 수익을",
      "자본에 대한",
      "회사의 글로벌 확장 전략에 따라 ",
    ],
    englishChunks: [
      "The CEO",
      "promised",
      "the investors",
      "a significant return",
      "on their capital",
      "following the company's global expansion strategy",
    ],
    fullEnglish:
      "The CEO promised the investors a significant return on their capital following the company's global expansion strategy.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 9,
    koreanChunks: [
      "회계 부서는",
      "지급했다",
      "컨설팅 회사에",
      "상당한 금액을",
      "수행한 것에 대해 철저한 재무감사를 ",
    ],
    englishChunks: [
      "The accounting department",
      "paid",
      "the consulting firm",
      "a substantial fee",
      "for conducting a thorough financial audit",
    ],
    fullEnglish:
      "The accounting department paid the consulting firm a substantial fee for conducting a thorough financial audit.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 10,
    koreanChunks: [
      "교육 코디네이터는",
      "배정했다",
      "각 참가자에게",
      "개인화된 학습 모듈을",
      "그들의 기술 수준과 직업적 배경을 기반으로",
    ],
    englishChunks: [
      "The training coordinator",
      "assigned",
      "each participant",
      "a personalized learning module",
      "based on their skill level and professional background",
    ],
    fullEnglish:
      "The training coordinator assigned each participant a personalized learning module based on their skill level and professional background.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 11,
    koreanChunks: [
      "워크숍 강사는",
      "보여주었다",
      "참가자들에게",
      "고급 기술을",
    ],
    englishChunks: [
      "The workshop instructor",
      "showed",
      "the participants",
      "advanced techniques",
    ],
    fullEnglish:
      "The workshop instructor showed the participants advanced techniques.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 12,
    koreanChunks: ["그 교수는", "가르쳤다", "학생들에게", "금융 분석 기술을"],
    englishChunks: [
      "The professor",
      "taught",
      "the students",
      "financial analysis skills",
    ],
    fullEnglish: "The professor taught the students financial analysis skills.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 13,
    koreanChunks: ["CEO는", "알렸다", "직원들에게", "새로운 정책 변경 사항을"],
    englishChunks: [
      "The CEO",
      "informed",
      "the employees",
      "the new policy changes",
    ],
    fullEnglish: "The CEO informed the employees the new policy changes.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 14,
    koreanChunks: ["회사는", "제공했다", "직원들에게", "유연한 근무 일정을"],
    englishChunks: [
      "The company",
      "offered",
      "employees",
      "flexible work schedules",
    ],
    fullEnglish: "The company offered employees flexible work schedules.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 15,
    koreanChunks: [
      "인사부는",
      "보냈다",
      "모든 지원자들에게",
      "상세한 면접 지침을",
    ],
    englishChunks: [
      "The HR department",
      "sent",
      "all candidates",
      "detailed interview guidelines",
    ],
    fullEnglish:
      "The HR department sent all candidates detailed interview guidelines.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 16,
    koreanChunks: [
      "매니저는",
      "제공했다",
      "팀에게",
      "건설적인 피드백을",
      "그들의 최근 프로젝트에 대한",
    ],
    englishChunks: [
      "The manager",
      "gave",
      "the team",
      "constructive feedback",
      " on their recent project",
    ],
    fullEnglish:
      "The manager gave the team constructive feedback on their recent project.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 17,
    koreanChunks: [
      "재무 분석가는",
      "제공했다",
      "투자자들에게",
      "정확한 시장 예측을",
    ],
    englishChunks: [
      "The financial analyst",
      "provided",
      "investors",
      "accurate market forecasts",
    ],
    fullEnglish:
      "The financial analyst provided investors accurate market forecasts.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 18,
    koreanChunks: [
      "회사는",
      "지급했다",
      "회사의 직원들에게",
      "후한 보너스를",
      "올해",
    ],
    englishChunks: [
      "The company",
      "paid",
      "its employees",
      "generous bonuses",
      "this year",
    ],
    fullEnglish: "The company paid its employees generous bonuses this year.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 19,
    koreanChunks: ["정부는", "제공했다", "소규모 기업들에게", "재정 지원을"],
    englishChunks: [
      "The government",
      "granted",
      "small businesses",
      "financial assistance",
    ],
    fullEnglish:
      "The government granted small businesses financial assistance.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
  {
    id: 20,
    koreanChunks: [
      "연구소는",
      "수여했다",
      "그 과학자에게",
      "보조금을",
      "추가 연구를 위한 ",
    ],
    englishChunks: [
      "The research institute",
      "awarded",
      "the scientist",
      "a grant",
      "for further studies",
    ],
    fullEnglish:
      "The research institute awarded the scientist a grant for further studies.",
    explanation:
      "주어(S) + 동사(V) + 간접목적어(IO) + 직접목적어(DO) 구조의 4형식 문장입니다.",
  },
];
